<template>
  <section id="prizes_carousel" class="trans_box">
    <h1>{{ $_translations.value.section_prize_title }}</h1>
    <h2>{{ $_translations.value.section_prize_description }}</h2>

    <Swiper
      class="swiper-container"
      :slides-per-view="1.8"
      :centered-slides="true"
      :space-between="10"
      :loop="prizes.length > 1"
      :breakpoints="swiperBreakpoints"
      @swiper="onSwiper"
    >
      <SwiperSlide v-for="prize in prizes" :key="prize.type">
        <div class="carousel-item">
          <BaseImage :src="prize.imgUrl" :alt="prize.type" />

          <h3>{{ $_translations.value[`section_prize_name_${ prize.type }`] }}</h3>

          <p>{{ prize.description }}</p>
        </div>
      </SwiperSlide>
    </Swiper>
  </section>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import BaseImage from '@/components/image/BaseImage.vue';
import usePrizesStore from '@/store/modules/prizes.js';
import useLocaleStore from '@/store/modules/locale.js';

import 'swiper/css';

// Store
const prizesStore = usePrizesStore();
const localeStore = useLocaleStore();

// Computed prizes from store
const prizes = computed(() => {
  const prizeData = prizesStore.carouselPrizes;

  // Duplicate prizes if length is 2 or 3 for better carousel display
  return [2, 3].includes(prizeData.length)
    ? prizeData.concat(prizeData)
    : prizeData;
});

// Computed swiper breakpoints that react to prizes length
const swiperBreakpoints = computed(() => ({
  510: {
    slidesPerView: 3,
    centeredSlides: true,
    allowTouchMove: true,
    spaceBetween: 10,
    loop: prizes.value.length > 1,
  },
}));

const onSwiper = (swiper) => {
  swiper.slideToLoop(0, 0, true);
};

// Load data on component mount
onMounted(async () => {
  await prizesStore.dispatchRetrievePrizes(localeStore.currentLanguage);
});
</script>
